import React,{Component} from 'react';



export default class Indemnities extends Component{
constructor(props){
  super(props);
  this.state ={
      data:[],
      isLoading:true,
      searchTerm:'',
  }
}


componentDidMount(){

  fetch('https://schoolportal.appsdesign.co.za/school/indemnities/'+ localStorage.getItem('schoolToken'))
             .then((response) => response.json())
             .then((responseJson) => {

               this.setState({
                 data: responseJson,
               }, function(){

               });

             })
             .catch((error) =>{
               console.error(error);
             });

}










render(){


const indems = this.state.data.map((ind,i) =>{
if(ind.eventID.includes(this.state.searchTerm) || ind.parentID.includes(this.state.searchTerm) || ind.childID.includes(this.state.searchTerm)){
return(

  <tr key={i}>
  <td>{ind.fmkclass}</td>
  <td>{ind.eventID}</td>
  <td>{ind.childID}</td>
  <td>{ind.parentID}</td>
  <td>{ind.permission ? 'YES' : 'NO'}</td>
  <td>{ind.conditions ? 'YES' : 'NO'}</td>
  <td>{ind.dateSaved}</td>
  <td>{ind.timeSaved}</td>


  </tr>



)
}
else{
  return null
}

})


  return(
  <div className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100,backgroundColor:'white'}}>

<h1>Indemnities</h1>
<div>
<label htmlFor="colid">
Search By Event ID, Child ID or Parent ID</label>
<input
type="text"
placeholder="Event/Parent/Child  ID"
id="colid"
className="pa2 ma2"
onKeyUp={(event) => this.setState({searchTerm:event.target.value})}
/>
<br/>

  </div>

  <table style={{ margin:10}}>
  <tbody>
  <tr>
<th>Class</th><th>Event ID</th>  <th>Child ID</th><th>Parent ID</th><th>Permission</th><th>Conditions</th><th>Date Saved</th><th>Time Saved</th>
  </tr>

{indems}
</tbody>
  </table>
</div>







  )
}


}



// WEBPACK FOOTER //
// ./src/components/FMK-EVENTS/Indemnities.js